/* kahwa-external-links.js
   Opens ordering / rewards links that leave kahwacoffee.com in a new tab, so the
   Kahwa site stays open behind them. Thanx (order ahead + rewards) is a separate
   platform with no link back to the main site, so leaving in the same tab strands
   the customer with only the browser back button.

   Applies to any link whose host is not the current host and matches the list
   below. Adds rel="noopener noreferrer" for security, and an accessible hint so
   screen readers announce that the link opens a new window. */
(function () {
  var EXTERNAL_HOSTS = [
    'thanx.com',
    'order.thanx.com',
    'signup.thanx.com'
  ];

  function isTargetHost(host) {
    for (var i = 0; i < EXTERNAL_HOSTS.length; i++) {
      var h = EXTERNAL_HOSTS[i];
      if (host === h || host.slice(-(h.length + 1)) === '.' + h) return true;
    }
    return false;
  }

  function decorate(root) {
    var links = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-kext') === '1') continue;
      var url;
      try { url = new URL(a.href, window.location.origin); } catch (e) { continue; }
      if (url.host === window.location.host) continue;
      if (!isTargetHost(url.host)) continue;

      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
      a.setAttribute('data-kext', '1');

      if (!a.querySelector('.visually-hidden[data-kext-label]')) {
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.setAttribute('data-kext-label', '');
        sr.textContent = ' (opens in a new tab)';
        a.appendChild(sr);
      }
    }
  }

  function init() {
    decorate(document);
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { decorate(document); }, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
